import { userInfoApi, certificationApi } from '@/api';
import { API_RETURN_CODE } from '@/utils/variables';

const actions = {};

/**
 * 유저 정보
 *  @param {*} param0
 */
actions.getUserInfo = ({ commit }) => {
  return userInfoApi.getUserInfo().then((res) => {
    if (res.data.code === API_RETURN_CODE.NO_ERROR) {
      commit('SET_USERINFO', res.data.data);
    }
    return res.data.code;
  });
};
/**
 * 유저 정보 등록
 *  @param {*} param0
 */
actions.setUserInfo = ({ commit }, val) => {
  return userInfoApi.setUserInfo(val).then((res) => {
    if (res.data.code === API_RETURN_CODE.NO_ERROR) {
      commit('UPDATE_USERINFO', val);
    }
    return res.data.code;
  });
};
/**
 * 유저 정보 업데이트
 *  @param {*} param0
 *  @param {Object}} val
 */
actions.updateUserInfo = ({ commit }, val) => {
  commit('UPDATE_USERINFO', val);
};
/**
 * 유저 연락처 수정
 *  @param {*} param0
 *  @param {Object}} val
 */
actions.setModifyContact = ({ commit }, val) => {
  return userInfoApi.modifyContact(val).then((res) => {
    if (res.data.code === API_RETURN_CODE.NO_ERROR) {
      commit('UPDATE_USERINFO', val);
    }
    return res.data.code;
  });
};
/**
 * 유저 전화번호 수정
 *  @param {*} param0
 *  @param {Object}} val
 */
actions.setModifyBusinessTelno = ({ commit }, val) => {
  return userInfoApi.modifyBusinessTelno(val).then((res) => {
    if (res.data.code === API_RETURN_CODE.NO_ERROR) {
      commit('UPDATE_USERINFO', val);
    }
    return res.data.code;
  });
};
/**
 * 유저 이메일 수정
 *  @param {*} param0
 *  @param {Object}} val
 */
actions.setModifyBusinessEmail = ({ commit }, val) => {
  return userInfoApi.modifyBusinessEmail(val).then((res) => {
    if (res.data.code === API_RETURN_CODE.NO_ERROR) {
      commit('UPDATE_USERINFO', val);
    }
    return res.data.code;
  });
};
/**
 * 계좌 실명 인증
 *  @param {*} param0
 *  @param {Object} val
 */
actions.checkBankAccount = ({}, val) => {
  return certificationApi.checkBankAccount(val).then((res) => {
    return res.data;
  });
};
/**
 * 개인 계좌정보 수정
 *  @param {*} param0
 *  @param {Object}} val
 */
actions.setModifyAccount = ({}, val) => {
  return userInfoApi.modifyAccount(val).then((res) => {
    return res.data;
  });
};
/**
 * 사업자 정보 수정
 *  @param {*} param0
 *  @param {Object}} val
 */
actions.setModifyBusinessAccount = ({}, val) => {
  return userInfoApi.modifyBusinessAccount(val).then((res) => {
    return res.data.code;
  });
};
/**
 * 유저 사업자 정보
 *  @param {*} param0
 *  @param {String}} val
 */
actions.setRegisterSelect = ({ commit }, val) => {
  commit('SET_REGISTERSELECT', val);
};
/**
 * 유저 이름 수정
 *  @param {*} param0
 *  @param {Object}} val
 */
actions.setModifyUserName = ({}, val) => {
  return userInfoApi.modifyUserName(val).then((res) => {
    return res.data.code;
  });
};
/**
 * 사업자 처리 내역​
 *  @param {*} param0
 */
actions.getBusinessUserInfo = ({ commit }) => {
  return userInfoApi.getBusinessUserInfo().then((res) => {
    if (res.data.code === API_RETURN_CODE.NO_ERROR) {
      commit('SET_USERINFOHISTORY', res.data.data.list);
    }
    return res.data.code;
  });
};
/**
 * 주민등록번호 인증
 *  @param {*} param0
 *  @param {String} val
 */
actions.checkIdentityNo = ({}, val) => {
  return certificationApi.checkIdentityNo(val).then((res) => {
    return res.data;
  });
};

actions.checkIdentityNoInCreate = ({}, val) => {
  return certificationApi.checkIdentityNoInCreate(val).then((res) => {
    return res.data;
  });
};

actions.checkBirthDay = ({}, val) => {
  return certificationApi.checkBirthDay(val).then((res) => {
    return res.data;
  });
};

actions.checkOTP = ({ commit }, val) => {
  commit('SET_HAS_OTP', val);
};

actions.delWithdrawalInfo = ({}) => {
  return userInfoApi.delWithdrawalInfo().then((res) => {
    return res.data.code;
  });
}

export default {
  ...actions,
};
